import {each} from './array/each';

const hyphenToCamelCase = (str) =>
    str.replace(/\b-([a-z])/g, (all, char) => char.toUpperCase());

const {length: LENGTH} = 'kui-';

const kuiset = (el) => {
    const set = {};
    each(el.attributes, (attribute) => {
        const att = attribute.nodeName.toLowerCase();
        if (att.length >= LENGTH && att.substring(0, LENGTH) === 'kui-') {
            set[hyphenToCamelCase(att.substring(LENGTH, att.length))] =
                attribute.nodeValue;
        }
    });

    return set;
};

export {kuiset};
